import CardSide from '@components/membership/CardSide';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useEffect, useRef } from 'react';

import styles from './styles.module.scss';

interface Props {
    count: number;
    hide?: boolean;
    shopName: string;
}

function SummaryCard({
  count, hide, shopName,
}:Props) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (hide) {
      ref.current?.classList?.add(styles.hide);
      return () => {};
    }
    const timeout = setTimeout(() => {
      ref.current?.classList?.remove(styles.hide);
    }, 250);
    return () => clearTimeout(timeout);
  }, [hide, ref]);
  return (
        <div className={`${styles.wrapper} `}
             ref={ref}>
            <div className={styles.contents}>
                <Row className={styles.top}>
                    <div className={styles.bar} />
                    <CardSide className={styles.side} color={colors.gray4}/>
                    <Text className={styles.shopName}>
                        {shopName}
                    </Text>
                </Row>
                <div className={styles.base} />
                <div className={styles.overlay} />
                <div className={styles.text}>
                    <Text size='lg' fontWeight='bold' color={colors.gray7}>
                        {count}개
                    </Text>
                </div>
            </div>
        </div>
  );
}

export default SummaryCard;
